import { qz } from "../client";
import { createNamespaceMutation } from "../internal/createNamespaceMutation";
import {
  hidStore,
  markHidClaimed,
  markHidStreamClosed,
  markHidStreamOpened,
  startHidListeningState,
  stopHidListeningState,
} from "./state";
import {
  type HidClaimInput,
  type HidOpenStreamInput,
  type HidReadInput,
  type HidReleaseInput,
  type HidSendFeatureInput,
  type HidSendInput,
} from "./types";

export const hidClaimDeviceMutationOptions = createNamespaceMutation({
  key: ["qz.hid.claimDevice"],
  run: async (deviceInfo: HidClaimInput) => {
    await qz.hid.claimDevice(deviceInfo);
    markHidClaimed(deviceInfo, true);
  },
  store: hidStore,
});

export const hidReleaseDeviceMutationOptions = createNamespaceMutation({
  key: ["qz.hid.releaseDevice"],
  run: async (deviceInfo: HidReleaseInput) => {
    await qz.hid.releaseDevice(deviceInfo);
    markHidClaimed(deviceInfo, false);
    markHidStreamClosed(deviceInfo);
  },
  store: hidStore,
});

export const hidOpenStreamMutationOptions = createNamespaceMutation({
  key: ["qz.hid.openStream"],
  run: async (deviceInfo: HidOpenStreamInput) => {
    await qz.hid.openStream(deviceInfo);
    markHidStreamOpened(deviceInfo);
  },
  store: hidStore,
});

export const hidCloseStreamMutationOptions = createNamespaceMutation({
  key: ["qz.hid.closeStream"],
  run: async (deviceInfo: HidClaimInput) => {
    await qz.hid.closeStream(deviceInfo);
    markHidStreamClosed(deviceInfo);
  },
  store: hidStore,
});

export const hidReadDataMutationOptions = createNamespaceMutation({
  key: ["qz.hid.readData"],
  run: (deviceInfo: HidReadInput) => qz.hid.readData(deviceInfo),
  store: hidStore,
});

export const hidSendDataMutationOptions = createNamespaceMutation({
  key: ["qz.hid.sendData"],
  run: async (deviceInfo: HidSendInput) => {
    await qz.hid.sendData(deviceInfo);
  },
  store: hidStore,
});

export const hidSendFeatureReportMutationOptions = createNamespaceMutation({
  key: ["qz.hid.sendFeatureReport"],
  run: async (deviceInfo: HidSendFeatureInput) => {
    await qz.hid.sendFeatureReport(deviceInfo);
  },
  store: hidStore,
});

export const hidStartListeningMutationOptions = createNamespaceMutation({
  key: ["qz.hid.startListening"],
  run: async () => {
    await qz.hid.startListening();
    startHidListeningState();
  },
  store: hidStore,
});

export const hidStopListeningMutationOptions = createNamespaceMutation({
  key: ["qz.hid.stopListening"],
  run: async () => {
    await qz.hid.stopListening();
    stopHidListeningState();
  },
  store: hidStore,
});
